// extracted by mini-css-extract-plugin
export default {"final__wrapper":"style_final__wrapper__P9ddz","final__content":"style_final__content__Z4yJR","final__img":"style_final__img__9mfHC","final__bottom":"style_final__bottom__NctWK"};